import { Chip } from "@mui/material";
import type { FC } from "react";
import { getTaskStatusChipColor } from "web_myplann/Tasks/Utils/getTaskStatusChipColor";

type Props = {
	name: string;
	statusId?: number | null;
};

export const TaskStatusBadge: FC<Props> = ({ name, statusId }) => (
	<Chip
		variant="status"
		color={getTaskStatusChipColor(statusId)}
		label={name}
	/>
);
